export default {
    auth: {
        login: '/login',
        register: '/register',
    },

    dashboard: '/dashboard',
    contact: '/contact',
    support: '/support',
    privacy: '/privacy-policy',
    gtc: '/gtc',
    imprint: '/imprint',
    team: '/team',

    my: {
        finisher_points: {
            index: '/my/finisherpoints'
        },
        profile: {
            edit: {
                settings: {
                    notifications: {
                        index: '/my/profile/edit/settings/notifications',
                        general: '/my/profile/edit/settings/notifications/general',
                        events: '/my/profile/edit/settings/notifications/events',
                        athletes: '/my/profile/edit/settings/notifications/athletes',
                        clubs: '/my/profile/edit/settings/notifications/clubs',
                    }
                }
            }
        }
    },

    users: {
        index: '/athletes',

        show: {
            index: '/athletes/{user}'
        },
        edit: '/athletes/{user}/edit',
    },

    clubs: {
        index: '/clubs',

        show: {
            index: '/clubs/{club}',
            membership: '/clubs/{club}/membership',
            contact: '/clubs/{club}/contact',
        },
        create: '/clubs/create'
    },

    events: {
        index: '/events',

        show: {
            index: '/events/{event}',
            membership: '/events/{event}/assignment',
        },

        activities: {
            index: '/events/{event}/news'
        },

        acquisition_campaigns: {
            index: '/events/{event}/campaigns'
        },

        live: {
            index: '/events/{event}/live'
        },

        community: {
            index: '/events/{event}/community'
        },

        participation_classes: {
            index: '/events/{event}/participation-classes'
        },

        participations: {
            index: '/events/{event}/participations',
            show: '/events/{event}/participations/{participation}',
        },

        results: {
            index: '/events/{event}/results',
        },

        ratings: {
            index: '/events/{event}/ratings'
        },

        jobs: {
            index: '/events/{event}/jobs'
        },

        map: {
            index: '/events/{event}/map'
        },

        products: {
            index: '/events/{event}/products'
        },

        shop: {
            index: '/events/{event}/shop'
        },

        awards: {
            index: '/events/{event}/awards'
        },

        sponsors: {
            index: '/events/{event}/sponsors'
        },

        gtc: {
            index: '/events/{event}/gtc'
        },

        impressions: {
            index: '/events/{event}/impressions'
        },

        contact: {
            index: '/events/{event}/contact'
        },
    },

    jobs: {
        index: '/jobs',
        events: {
            jobs: {
                show: '/jobs/events/{event}/{job}'
            }
        },
        clubs: {
            jobs: {
                show: '/jobs/clubs/{club}/{job}'
            }
        },
        companies: {
            jobs: {
                show: '/jobs/companies/{club}/{job}'
            }
        }
    },

    news: {
        index: '/news',
        show: '/news/{article}',
    },

    blog: {
        index: '/blog',
        show: '/blog/{article}',
    }
}